import React from 'react';
import { connect } from 'react-redux';
// Material UI
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

function SelectClan({ clans, clan, setClan }) {
  const classes = useStyles();
  const handleClanSelect = (e) => {
    setClan(e.target.value);
  };
  return (
    <FormControl className={classes.formControl}>
      <InputLabel>Domicilio</InputLabel>
      <Select value={clan} onChange={handleClanSelect}>
        <MenuItem value={0}>Todos</MenuItem>
        {clans.map(({ address, id }, i) => (
          <MenuItem value={id} key={i}>
            {address}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

const mapStateToProps = (state) => ({
  clans: state.clans.data,
});

export default connect(mapStateToProps)(SelectClan);
